
var Navbar = (function() {

    function Navbar(id) {
        var self = this;
        this.el = document.getElementById(id);

        this.menuToggle = this.el.getElementsByClassName('c-navbar-toggle')[0];
        this.menuWrapper = this.el.getElementsByClassName('c-navbar-menu-wrapper')[0];
        
        this.menuToggle.addEventListener('click', function(event) {
            event.preventDefault();
            self.menuToggle.classList.toggle('c-navbar-toggle-active');
            self.menuWrapper.classList.toggle('c-navbar-menu-wrapper-hidden');
        })        
    }

    return Navbar;
}());

export default Navbar;
